export default "__VITE_ASSET__tVPs3grl__"